import {
  arbitrum,
  assethub,
  bitcoin,
  bsc,
  ethereum,
  polkadot,
  solana,
  tron,
} from '@/shared/assets/chains';
import { NATIVE_TOKEN_ADDRESS } from '@/shared/assets/tokens/constants';
import { type ChainflipToken, type AnyChainflipToken } from '.';

export const btc$ = {
  chain: bitcoin,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Bitcoin',
  symbol: 'BTC',
  decimals: 8,
  chainflipId: 'Btc',
  assetAndChainName: 'BTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const dot$ = {
  chain: polkadot,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Polkadot',
  symbol: 'DOT',
  decimals: 10,
  chainflipId: 'Dot',
  assetAndChainName: 'DOT',
  isStablecoin: false,
} as const satisfies AnyChainflipToken;

export const eth$ = {
  chain: ethereum,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
  chainflipId: 'Eth',
  assetAndChainName: 'ETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const flip$ = {
  chain: ethereum,
  address: '0x826180541412D574cf1336d22c0C0a287822678A',
  name: 'Chainflip',
  symbol: 'FLIP',
  decimals: 18,
  chainflipId: 'Flip',
  assetAndChainName: 'FLIP',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const usdc$ = {
  chain: ethereum,
  address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  chainflipId: 'Usdc',
  assetAndChainName: 'USDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const usdt$ = {
  chain: ethereum,
  address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  name: 'USD Tether',
  symbol: 'USDT',
  decimals: 6,
  chainflipId: 'Usdt',
  assetAndChainName: 'USDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const wbtc$ = {
  chain: ethereum,
  address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  name: 'Wrapped Bitcoin',
  symbol: 'WBTC',
  decimals: 8,
  chainflipId: 'Wbtc',
  assetAndChainName: 'WBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const arbusdc$ = {
  chain: arbitrum,
  address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  chainflipId: 'ArbUsdc',
  assetAndChainName: 'arbUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const arbusdt$ = {
  chain: arbitrum,
  address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  name: 'USD Tether',
  symbol: 'USDT',
  decimals: 6,
  chainflipId: 'ArbUsdt',
  assetAndChainName: 'arbUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const arbeth$ = {
  chain: arbitrum,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
  chainflipId: 'ArbEth',
  assetAndChainName: 'arbETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const sol$ = {
  chain: solana,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Solana',
  symbol: 'SOL',
  decimals: 9,
  chainflipId: 'Sol',
  assetAndChainName: 'SOL',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const solusdc$ = {
  chain: solana,
  address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  chainflipId: 'SolUsdc',
  assetAndChainName: 'solUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const solusdt$ = {
  chain: solana,
  address: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
  name: 'USD Tether',
  symbol: 'USDT',
  decimals: 6,
  chainflipId: 'SolUsdt',
  assetAndChainName: 'solUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const hubdot$ = {
  chain: assethub,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Polkadot',
  symbol: 'DOT',
  decimals: 10,
  chainflipId: 'HubDot',
  assetAndChainName: 'hubDOT',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const hubusdc$ = {
  chain: assethub,
  address: '1337',
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  chainflipId: 'HubUsdc',
  assetAndChainName: 'hubUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const hubusdt$ = {
  chain: assethub,
  address: '1984',
  name: 'USD Tether',
  symbol: 'USDT',
  decimals: 6,
  chainflipId: 'HubUsdt',
  assetAndChainName: 'hubUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const trx$ = {
  chain: tron,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Tron',
  symbol: 'TRX',
  decimals: 6,
  chainflipId: 'Trx',
  assetAndChainName: 'TRX',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const trxusdt$ = {
  chain: tron,
  address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
  name: 'USD Tether',
  symbol: 'USDT',
  decimals: 6,
  chainflipId: 'TrxUsdt',
  canonicalSymbol: 'USDT',
  assetAndChainName: 'trxUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const cbbtc$ = {
  chain: ethereum,
  address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
  name: 'Coinbase Wrapped BTC',
  symbol: 'cbBTC',
  decimals: 8,
  chainflipId: 'Cbbtc',
  assetAndChainName: 'cbBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bnb$ = {
  chain: bsc,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'BNB',
  symbol: 'BNB',
  decimals: 18,
  chainflipId: 'Bnb',
  assetAndChainName: 'BNB',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bscusdt$ = {
  chain: bsc,
  address: '0x55d398326f99059fF775485246999027B3197955',
  name: 'BNB Chain USDT',
  symbol: 'USDT',
  // BSC USDT is an 18-decimal contract, unlike USDT on every other supported chain
  decimals: 18,
  chainflipId: 'BscUsdt',
  canonicalSymbol: 'USDT',
  assetAndChainName: 'bscUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export default [
  btc$,
  eth$,
  dot$,
  flip$,
  usdc$,
  usdt$,
  wbtc$,
  cbbtc$,
  arbusdc$,
  arbusdt$,
  arbeth$,
  sol$,
  solusdc$,
  solusdt$,
  hubdot$,
  hubusdt$,
  hubusdc$,
  trx$,
  trxusdt$,
  bnb$,
  bscusdt$,
];
